export const NotificationsName = 'Notifications';
